import Highcharts from 'highcharts';
import { HighchartsReact } from 'highcharts-react-official';

export interface AnalyticsLineChartProps {
  options?: Highcharts.Options;
}

export const LineChart = ({ options }: AnalyticsLineChartProps) => {
  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};
